<div class="w-full" (appClickOutside)="onClickOutside()">
    @if (installation?.installations.length > 1) {
        <span [translate]="title"></span>
    }

    <div>
        @switch (installation?.installations.length) {
            @case (1) {
                @for (installation of installation?.installations; track installation) {
                    <span class="flex flex-col body-copy whitespace-pre-line">
                        <app-installation-cell
                            [installation]="installation"
                            [showAddress]="showAddress"
                            [showMeterInfo]="true"
                        ></app-installation-cell>
                    </span>
                }
            }
            @default {
                <mat-radio-group
                    class="installation-radio-group gap-10px pt-10px sm:pt-20px"
                    [name]="childRadioName"
                    [value]="isParentSelected ? installation.selectedInstallation.installationNumber : null"
                    (change)="selectInstallation($event.value)"
                >
                    @for (i of installation.installations; track i) {
                        <mat-radio-button
                            class="installation-radio brand-radio"
                            [name]="childRadioName"
                            [value]="i.installationNumber"
                        >
                            <div class="radio-content">
                                <div class="radio-text">
                                    <app-installation-cell
                                        [installation]="i"
                                        [showAddress]="showAddress"
                                        [showMeterInfo]="true"
                                    ></app-installation-cell>
                                </div>
                            </div>
                        </mat-radio-button>
                    }
                </mat-radio-group>
            }
        }
    </div>
</div>
